import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menupoint } from '../model.module/menupoint.model';
import { AuthService } from '../services.module/auth.service';
import { NachrichtenApiService } from '../../generated/api/nachrichten/nachrichten.service';
import { VertraegeService } from '../providers.module/vertraege.service';
import { HttpContext } from '@angular/common/http';
import { CACHE_OPTIONS, enableCache } from '../services.module/http-cache.tokens';
import { take } from 'rxjs';

@Component({
    selector: 'elem-menupoint',
    templateUrl: './menupoint.component.html',
    styleUrls: ['./menupoint.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenupointComponent implements OnInit, OnDestroy {

    @Input()
    menupoint: Menupoint;

    @Input()
    active: boolean;

    @Input()
    hidden = false;

    @Input()
    first = false;

    subPage: string;

    nachrichtenAnzahl: number;

    private sub: any;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly authService: AuthService,
        private readonly vertraegeService: VertraegeService,
        private readonly nachrichtenApiService: NachrichtenApiService
    ) {
    }

    loadNachrichtenAnzahl(): void {
        if (this.menupoint.name !== 'posteingang') {
            return;
        }

        const activeKunde = this.authService.getActiveKunde();

        // Wenn aktuell kein Kunde aktiv ist, müssen auch keine Nachrichten geladen werden
        if (!activeKunde) {
            return;
        }

        this.vertraegeService.getVertraegeNummernListe()
            .pipe(take(1))
            .subscribe(vertraegeList => {
                const vsnrs = vertraegeList.map(vertrag => vertrag.vsnrNumerisch);

                // Für /nachrichten/byVsnrs kann man kurzes Caching aktivieren, auch wenn es POST ist
                const context = new HttpContext().set(
                    CACHE_OPTIONS,
                    enableCache({ ttlMs: 5_000, staleWhileRevalidate: true })
                );

                this.nachrichtenApiService.getNachrichtenByVsnrs({ vsnrs }, { context })
                    .pipe(take(1))
                    .subscribe(nachrichtenResponse => {
                        // Keine Nachrichten verfügbar
                        if (!nachrichtenResponse.nachrichten || !nachrichtenResponse.nachrichten.length) {
                            this.nachrichtenAnzahl = 0;
                            return;
                        }

                        // Ermittle Anzahl ungelesener Nachrichten
                        this.nachrichtenAnzahl = nachrichtenResponse.nachrichten.reduce(
                            (counter, nachricht) => nachricht.gelesen ? counter : counter + 1,
                            0
                        );
                    });
            });
    }

    ngOnInit() {
        if (this.menupoint.children && this.menupoint.children.length !== 0) {
            this.sub = this.route.params.subscribe(params => {
                this.subPage = this.resolveSubPage(params['subPage']);
            });
        }

        this.loadNachrichtenAnzahl();
    }

    // Ermittelt die aktive Unterseite fuer die Menue-Hervorhebung.
    // Routen mit :subPage-Parameter liefern diesen direkt; Routen mit explizitem Pfad
    // (z.B. Firmenverbuende) haben keinen Parameter, daher Fallback auf das letzte URL-Segment.
    private resolveSubPage(subPageParam: string): string {
        if (subPageParam) {
            return decodeURI(subPageParam).replace('%2F', '/');
        }

        const primary = this.router.parseUrl(this.router.url).root.children['primary'];
        const segments = primary ? primary.segments : [];
        return segments.length ? segments[segments.length - 1].path : '';
    }

    ngOnDestroy() {
        if (this.menupoint.children && this.menupoint.children.length !== 0 && this.sub) {
            this.sub.unsubscribe();
        }
    }

    click(): void {
        if (this.menupoint.targetUri) {
            if (this.menupoint.targetUri.startsWith('http')) {
                window.open(this.menupoint.targetUri, '_blank', 'noopener,noreferrer');
            } else {
                this.router.navigate([this.menupoint.targetUri]);
            }
        }
    }

    subclick(i): void {
        if (this.menupoint.children[i].targetUri && !this.menupoint.children[i].defekt) {
            this.router.navigate([this.menupoint.targetUri, this.menupoint.children[i].targetUri]);
        }
    }

}
